import React from 'react';
import classnames from 'classnames';
import './toggle_field.scss';

interface Props {
  name?: string;
  value: boolean;
  label?: string;
  onChange: (value: boolean) => void;
}

export function ToggleField({ name, value, label, onChange }: Props): JSX.Element {
  return (
    <div className="toggle-field">
      {label && (
        <label htmlFor={name} className="toggle-field__label">
          {label}
        </label>
      )}
      <div
        className={classnames('toggle-field__toggle', {
          'toggle-field__toggle--checked': value,
        })}
      >
        <input
          name={name}
          type="checkbox"
          checked={value}
          onChange={(e) => onChange(e.target.checked)}
          className="toggle-field__input"
        />
      </div>
    </div>
  );
}
